module.exports = __webpack_public_path__ + "img/AX.d78ede0e.svg";